import queueSoundUrl from "@/assets/sounds/queue-sound.mp3"
import passConstants from "@/constants/passConstants"
import visitorConstants from "@/constants/visitorConstants"
import {
  SHA256_INITIAL_HASH,
  SHA256_ROUND_CONSTANTS
} from "@/constants/sha256Constants"
import moment from "moment-timezone"
import store from "@/store/index"
import { cloneDeep } from "lodash"

const helpers = {
  currTzDateTime: (date, time, format = "YYYY-MM-DD HH:mm") => {
    let newDate = new Date(date).toLocaleDateString("en-GB") + " " + time
    newDate = moment(newDate, "DD-MM-YYYY HH:mm")
    return helpers.transformDateTime(newDate, format)
  },
  currTzDate: (date, format = "MM/DD/YYYY") => {
    let newDate = new Date(date).toLocaleDateString("en-GB")
    newDate = moment(newDate, "DD-MM-YYYY")
    return helpers.transformDate(newDate, format)
  },
  getTommorowDate: (format = "MM/DD/YYYY") => {
    let newDate = new Date().toLocaleDateString("en-GB")
    newDate = moment().add(1, "days").format(format).toString()
    return newDate
  },
  getToday: (format = "MM/DD/YYYY hh:mm A") => {
    return moment().format(format).toString()
  },
  transformUTC(date, format = "MM/DD/YYYY hh:mm A") {
    return moment.utc(date).tz(moment().tz()).format(format)
  },
  transformDateTime: (date, format, zone) => {
    const _date = moment(date).format(format ? format : "MM/DD/YYYY HH:mm")
    const _zone = zone ? zone : " " + moment().tz()
    return _date + _zone
  },
  getHTMLDateTime: (
    date,
    formatDate = "MM/DD/YYYY",
    formatTime = "HH:mm",
    separator = "&nbsp;&nbsp;"
  ) => {
    //readonly
    const _date = moment(date).format(formatDate)
    const _time = moment(date).format(formatTime)
    return _date + separator + _time
  },
  transformDate: (date, format) => {
    return moment(date).format(format ? format : "MM/DD/YYYY")
  },
  addMinutesToTime: (time, minutes, fromFormat, toFormat) => {
    return moment(time, fromFormat ? fromFormat : "HH:mm")
      .add(minutes, "minutes")
      .format(toFormat ? toFormat : "HH:mm")
  },
  removeMinutesFromTime: (time, minutes) => {
    return moment(time, "HH:mm").subtract(minutes, "minutes").format("HH:mm")
  },
  formatDate(date, formatFrom, formatТо) {
    return formatFrom
      ? moment(date, formatFrom).format(formatТо)
      : moment(date).format(formatТо)
  },
  date(date) {
    return date ? moment(date) : moment()
  },
  getEndOfTheDay() {
    return moment().format("YYYY-MM-DD 23:59:59")
  },
  secondsToTimeString(SECONDS) {
    return new Date(SECONDS * 1000).toISOString().substr(11, 8)
  },
  checkForNotificationSound(payload = null) {
    const currentUser = store.getters["authentication/user"]
    const isUserMuted = !currentUser.audio_enabled
    let play = !isUserMuted

    if (payload && Object.hasOwnProperty.call(payload, "notifyAdultsIds")) {
      if (Array.isArray(payload.notifyAdultsIds)) {
        play = !isUserMuted && payload.notifyAdultsIds.includes(currentUser.id)
      } else {
        play = false
      }
    }
    if (play) {
      this.playNotificationSound()
    }
  },
  playNotificationSound(config = {}) {
    const { playQueueSound = false } = config

    if (playQueueSound) {
      const audio = new Audio(queueSoundUrl)
      audio.play().catch((e) => {
        // eslint-disable-next-line no-console
        console.warn("Failed to play queue sound:", e)
      })
      return
    }
    const notificationsAudio = document.getElementById("notifications-audio")
    if (notificationsAudio) {
      notificationsAudio.currentTime = 0
      notificationsAudio.muted = true //Chrome problem fix
      notificationsAudio.play()
      notificationsAudio.muted = false //Chrome problem fix
    }
  },
  stopNotificationSound() {
    const notificationsAudio = document.getElementById("notifications-audio")
    if (notificationsAudio) {
      notificationsAudio.pause()
      notificationsAudio.currentTime = 0
    }
  },
  scrollToTop() {
    const container = document.getElementsByClassName(
      "main-scroll-container"
    )[0]
    container.scrollTo({
      top: 0,
      left: 0
    })
  },
  setModalToggleClass(value) {
    const body = document.getElementsByTagName("body")
    if (value) {
      body[0].classList.add("modal-opened")
    } else {
      body[0].classList.remove("modal-opened")
    }
  },
  getBadgeFlags(pass) {
    const flags = {
      active: false,
      canceled: false,
      edited: false,
      ended: false,
      extended: false,
      min_time: false,
      missed: false,
      missed_request: false,
      system_completed: false,
      waiting_approval: false,
      limit_exceeded: false
    }
    // Waiting approval
    if (
      !pass.approved_at &&
      !pass.expired_at &&
      !pass.canceled_at &&
      pass.pass_status == 1
    ) {
      flags.waiting_approval = true
    }
    //extended FE check =

    if (pass.child) {
      if (
        pass.child.extended_at !== null &&
        pass.child.system_completed == 1 &&
        pass.pass_status == 0
      ) {
        flags.extended = true
      }
    }

    if (
      pass.extended_at !== null &&
      pass.completed_at &&
      pass.system_completed == 1
    ) {
      flags.extended = true
    }

    if (
      pass.extended_at &&
      pass.system_completed == 1 &&
      pass.pass_status == 0
    ) {
      flags.extended = true
    }
    //system_ended FE check =
    if (
      pass.child === null &&
      pass.system_completed == 1 &&
      pass.extended_at == null
    ) {
      flags.system_completed = true
    }

    if (
      pass.child &&
      pass.extended_at == null &&
      pass.child.system_completed == 1 &&
      pass.child.extended_at == null
    ) {
      flags.system_completed = true
    }

    if (
      pass.child &&
      pass.child.type === "APT" &&
      pass.child.expired_at !== null &&
      !pass.child.system_completed &&
      pass.child.extended_at === null
    ) {
      flags.system_completed = true
    }
    //Cancelled
    if (pass.canceled_at) {
      flags.canceled = true
    }
    //Edited
    if (pass.edited_at !== null) {
      flags.edited = true
    }
    //Active
    if (
      (pass.pass_status == 1 && pass.approved_at) ||
      (pass.child && pass.child.pass_status == 1)
    ) {
      flags.active = true
    }
    //Ended
    if (pass.child) {
      if (
        pass.child.approved_at &&
        !pass.child.pass_status &&
        !pass.child.canceled_at &&
        !pass.child.expired_at
      ) {
        flags.ended = true
      }

      if (
        pass.child.extended_at &&
        pass.child.system_completed &&
        !pass.pass_status &&
        !pass.child.pass_status
      ) {
        flags.ended = true
      }
    }

    if (!pass.child) {
      if (
        pass.completed_at &&
        pass.pass_status == 0 &&
        !pass.canceled_at &&
        !pass.expired_at
      ) {
        flags.ended = true
      }

      if (pass.extended_at && pass.completed_at && pass.system_completed) {
        flags.ended = true
      }

      if (pass.extended_at && pass.system_completed && !pass.pass_status) {
        flags.ended = true
      }
    }

    //min_time
    if (
      (pass.flagged_at !== null && !pass.child && !pass.extended_at) ||
      (pass.child && pass.flagged_at && !pass.child.extended_at)
    ) {
      flags.min_time = true
    }

    if (pass.child && pass.child.flagged_at && !pass.child.extended_at) {
      flags.min_time = true
    }

    if (pass.extended_at && pass.flagged_at && pass.pass_status) {
      flags.min_time = true
    }

    if (pass.child && pass.extended_at && pass.flagged_at) {
      flags.min_time = true
    }

    if (
      pass.child &&
      pass.child.flagged_at &&
      pass.child.extended_at &&
      pass.child.pass_status
    ) {
      flags.min_time = true
    }

    //missed FE check:

    if (
      pass.expired_at &&
      !pass.pass_status &&
      !pass.system_completed &&
      !pass.approved_at
    ) {
      flags.missed = true
    }

    if (Number(pass?.limit_exceeded) === 1) {
      flags.limit_exceeded = true
    }

    return flags
  },
  isPassSystemEnded(pass) {
    return (
      (!pass.parent &&
        pass.completed_by === null &&
        pass.completed_at !== null &&
        pass.type !== "SLP") ||
      (pass.parent &&
        pass.approved_by === null &&
        pass.approved_at !== null &&
        pass.completed_at === null &&
        pass.completed_by === null &&
        pass.parent &&
        pass.type !== "SLP") ||
      (pass.parent &&
        pass.completed_at !== null &&
        pass.completed_by == null &&
        pass.type !== "SLP")
    )
  },
  getTotalTime(pass) {
    if (pass.approved_at && pass.completed_at && !pass.child) {
      const diff = new Date(
        moment
          .duration(moment(pass.completed_at).diff(moment(pass.approved_at)))
          .asMilliseconds()
      )
        .toISOString()
        .substr(11, 8)
      //diff between pass.approved_at and pass.child.completed_at in HH:mm:ss format
      return diff
    }

    if (
      pass.child &&
      pass.child.completed_at &&
      pass.child.approved_at &&
      pass.approved_at
    ) {
      const diff = new Date(
        moment
          .duration(
            moment(pass.child.completed_at).diff(moment(pass.approved_at))
          )
          .asMilliseconds()
      )
        .toISOString()
        .substr(11, 8)
      //diff between pass.approved_at and pass.child.completed_at in HH:mm:ss format
      return diff
    }

    if (
      pass.child &&
      !pass.child.completed_at &&
      pass.child.approved_at &&
      pass.approved_at
    ) {
      //diff between pass.approved_at and pass.child.approved_at in HH:mm:ss format
      const diff = new Date(
        moment
          .duration(
            moment(pass.child.approved_at).diff(moment(pass.approved_at))
          )
          .asMilliseconds()
      )
        .toISOString()
        .substr(11, 8)
      return diff
    }
  },
  setUserAssignedRoomsPerPass(pass) {
    const usersAssignedRooms =
      store.getters["dashboardTable/usersAssignedRooms"]
    if (pass.from) {
      pass.from.user_ids_assigned =
        usersAssignedRooms[pass.from.trip_type ? "rooms" : "users"][
          pass.from.id
        ] || []
    }
    if (pass.to) {
      pass.to.user_ids_assigned =
        usersAssignedRooms[pass.to.trip_type ? "rooms" : "users"][pass.to.id] ||
        []
    }
    if (pass.child != null) {
      pass.child.to.user_ids_assigned =
        usersAssignedRooms[pass.child.to.trip_type ? "rooms" : "users"][
          pass.child.to.id
        ] || []
      pass.child.from.user_ids_assigned =
        usersAssignedRooms[pass.child.from.trip_type ? "rooms" : "users"][
          pass.child.from.id
        ] || []
    }
    return pass
  },
  isMyPass(pass) {
    //counts as my pass if I am assigned to location and it doesn't matter if  interacted with it
    const user = store.getters["authentication/user"]
    if (pass.approved_by === user.id || pass.completed_by === user.id) {
      return true
    }

    if (pass.from) {
      if (
        (pass.from_type === "App\\Models\\User" && pass.from.id === user.id) ||
        (pass.from_type === "App\\Models\\Room" &&
          pass.from.user_ids_assigned &&
          pass.from.user_ids_assigned.includes(user.id))
      ) {
        return true
      }
    }

    if (pass.to) {
      if (
        (pass.to_type === "App\\Models\\User" && pass.to.id === user.id) ||
        (pass.to_type === "App\\Models\\Room" &&
          pass.to.user_ids_assigned &&
          pass.to.user_ids_assigned.includes(user.id))
      ) {
        return true
      }
    }

    if (pass.child) {
      if (
        pass.child.approved_by === user.id ||
        pass.child.completed_by === user.id
      ) {
        return true
      }

      if (pass.child.from) {
        if (
          (pass.child.from_type === "App\\Models\\User" &&
            pass.child.from.id === user.id) ||
          (pass.child.from_type === "App\\Models\\Room" &&
            pass.child.from.user_ids_assigned &&
            pass.child.from.user_ids_assigned.includes(user.id))
        ) {
          return true
        }
      }

      if (pass.child.to) {
        if (
          (pass.child.to_type === "App\\Models\\User" &&
            pass.child.to.id === user.id) ||
          (pass.child.to_type === "App\\Models\\Room" &&
            pass.child.to.user_ids_assigned &&
            pass.child.to.user_ids_assigned.includes(user.id))
        ) {
          return true
        }
      }
    }
    return false
  },
  doesCountMyPass(pass) {
    //counts as my pass if I am assigned to location and i interacted with it
    const user = store.getters["authentication/user"]
    if (pass.approved_by === user.id || pass.completed_by === user.id) {
      return true
    }

    if (pass.from) {
      if (
        (pass.from_type === "App\\Models\\User" && pass.from.id === user.id) ||
        (pass.from_type === "App\\Models\\Room" &&
          pass.from.user_ids_assigned &&
          pass.from.user_ids_assigned.includes(user.id) &&
          pass.approved_by === user.id)
      ) {
        return true
      }
    }

    if (pass.to) {
      if (
        (pass.to_type === "App\\Models\\User" && pass.to.id === user.id) ||
        (pass.to_type === "App\\Models\\Room" &&
          pass.to.user_ids_assigned &&
          pass.to.user_ids_assigned.includes(user.id) &&
          pass.completed_by === user.id)
      ) {
        return true
      }
    }

    if (pass.child) {
      if (
        pass.child.approved_by === user.id ||
        pass.child.completed_by === user.id
      ) {
        return true
      }

      if (pass.child.from) {
        if (
          (pass.child.from_type === "App\\Models\\User" &&
            pass.child.from.id === user.id) ||
          (pass.child.from_type === "App\\Models\\Room" &&
            pass.child.from.user_ids_assigned &&
            pass.child.from.user_ids_assigned.includes(user.id) &&
            pass.child.approved_by === user.id)
        ) {
          return true
        }
      }

      if (pass.child.to) {
        if (
          (pass.child.to_type === "App\\Models\\User" &&
            pass.child.to.id === user.id) ||
          (pass.child.to_type === "App\\Models\\Room" &&
            pass.child.to.user_ids_assigned &&
            pass.child.to.user_ids_assigned.includes(user.id) &&
            pass.child.completed_by === user.id)
        ) {
          return true
        }
      }
    }
    return false
  },
  filterByTab(pass) {
    const activePassState = store.getters["dashboardTable/getStatus"]
    const isActiveDashboardUpdate =
      store.getters["dashboardTable/isActiveDashboardUpdate"]
    const allowedInActivePasses =
      store.getters["dashboardTable/allowedInActivePasses"]

    if (activePassState != "active" && pass.canceled_at) {
      return false
    }
    if (activePassState == "both") {
      return true
    }
    if (activePassState == "active" && !isActiveDashboardUpdate) {
      return allowedInActivePasses.includes(pass.id)
    } else {
      if (activePassState == "active" && pass.pass_status == 1) {
        return true
      }
      if (
        activePassState == "active" &&
        pass.child &&
        pass.child.pass_status == 1
      ) {
        return true
      }
    }

    if (activePassState == "ended" && pass.pass_status == 0 && !pass.child) {
      return true
    }
    if (
      activePassState == "ended" &&
      pass.pass_status == 0 &&
      pass.child.pass_status == 0
    ) {
      return true
    }
    return false
  },
  filterAptPassesByTab(aptPass, aptTypeParam) {
    const aptType = aptTypeParam
      ? aptTypeParam
      : store.getters["dashboardTable/getType"]

    const user = store.getters["authentication/user"]
    //for appts on the Dashboard
    if (aptType != "appointment") {
      const userAssignedRooms = this.getUserAssignedRooms(user)
      const isToUser =
        aptPass.to_type === "App\\Models\\User" && aptPass.to.id === user.id
      const isToRoom =
        aptPass.to_type === "App\\Models\\Room" &&
        userAssignedRooms &&
        userAssignedRooms.includes(aptPass.to.id)
      const isFromUser =
        aptPass.from_type === "App\\Models\\User" && aptPass.from.id === user.id
      const isFromRoom =
        aptPass.from_type === "App\\Models\\Room" &&
        userAssignedRooms &&
        userAssignedRooms.includes(aptPass.from.id)
      const isConfirmed = !!aptPass?.confirmed_by_user || false
      if (
        //only for today's appointments
        aptType == "appointments_today" &&
        !aptPass.waiting_activation &&
        !aptPass.is_ended &&
        !aptPass.is_missed &&
        !aptPass.is_today_waiting_confirmation &&
        !aptPass.is_activated &&
        !aptPass.canceled_from_dashboard &&
        !aptPass.is_long_running &&
        aptPass.individual_pass_state != "RUNNING" &&
        aptPass.individual_pass_state != "LONG_RUNNING" &&
        (moment(aptPass.for_date).isSame(moment(), "day") ||
          aptPass.is_missed_request) &&
        (isToUser || isToRoom || ((isFromUser || isFromRoom) && isConfirmed))
      ) {
        return true
        //for today_awaiting and future_awaiting
      } else {
        if (
          (aptPass.to_type === "App\\Models\\User" &&
            aptPass.to.id === user.id) ||
          (aptPass.to_type === "App\\Models\\Room" &&
            userAssignedRooms &&
            userAssignedRooms.includes(aptPass.to.id))
        ) {
          if (
            aptType == "appointments_future_awaiting" &&
            !aptPass.is_missed_request &&
            aptPass.is_future_waiting_confirmation
          ) {
            return true
          }
          if (
            aptType == "appointments_awaiting" &&
            !aptPass.is_missed_request &&
            aptPass.is_today_waiting_confirmation
          ) {
            return true
          }
        }
      }
    }
    return false
  },
  getUserAssignedRooms(user) {
    const allUsersAssignedRooms =
      store.getters["dashboardTable/usersAssignedRooms"]
    if (
      user &&
      allUsersAssignedRooms &&
      allUsersAssignedRooms.users &&
      allUsersAssignedRooms.users[user.id]
    ) {
      return allUsersAssignedRooms.users[user.id]
    }
  },
  sortPassesByColumn(column, a, b) {
    const date = moment().add(1, "day")
    if (column == "user.last_name:asc") {
      return a.user.last_name.localeCompare(b.user.last_name)
    }
    if (column == "user.last_name:desc") {
      return b.user.last_name.localeCompare(a.user.last_name)
    }
    if (column == "elastic_advanced_fields.approve_time_only:asc") {
      return (
        moment(a.approved_at || date).valueOf() -
        moment(b.approved_at || date).valueOf()
      )
    }
    if (column == "elastic_advanced_fields.approve_time_only:desc") {
      return (
        moment(b.approved_at || date).valueOf() -
        moment(a.approved_at || date).valueOf()
      )
    }
    if (column == "elastic_advanced_fields.completed_time_only:asc") {
      return (
        moment(a.completed_at || date).valueOf() -
        moment(b.completed_at || date).valueOf()
      )
    }
    if (column == "elastic_advanced_fields.completed_time_only:desc") {
      return (
        moment(b.completed_at || date).valueOf() -
        moment(a.completed_at || date).valueOf()
      )
    }

    if (column == "elastic_advanced_fields.approve_child_time_only:asc") {
      return (
        moment((a.child && a.child.approved_at) || date).valueOf() -
        moment((b.child && b.child.approved_at) || date).valueOf()
      )
    }
    if (column == "elastic_advanced_fields.approve_child_time_only:desc") {
      return (
        moment((b.child && b.child.approved_at) || date).valueOf() -
        moment((a.child && a.child.approved_at) || date).valueOf()
      )
    }
    if (column == "elastic_advanced_fields.completed_child_time_only:asc") {
      return (
        moment((a.child && a.child.completed_at) || date).valueOf() -
        moment((b.child && b.child.completed_at) || date).valueOf()
      )
    }
    if (column == "elastic_advanced_fields.completed_child_time_only:desc") {
      return (
        moment((b.child && b.child.completed_at) || date).valueOf() -
        moment((a.child && a.child.completed_at) || date).valueOf()
      )
    }
    if (column == "total_time:asc") {
      const left = a.total_time ? parseInt(a.total_time.replaceAll(":", "")) : 0
      const right = b.total_time
        ? parseInt(b.total_time.replaceAll(":", ""))
        : 0
      return left - right
    }
    if (column == "total_time:desc") {
      const left = a.total_time ? parseInt(a.total_time.replaceAll(":", "")) : 0
      const right = b.total_time
        ? parseInt(b.total_time.replaceAll(":", ""))
        : 0
      return right - left
    }
    if (column == "type:asc") {
      return a.type.localeCompare(b.type)
    }
    if (column == "type:desc") {
      return b.type.localeCompare(a.type)
    }
    return b.id - a.id
  },
  isUserAssignedToRoom(aptPass) {
    const user = store.getters["authentication/user"]
    const userAssignedRooms = this.getUserAssignedRooms(user)
    return (
      (aptPass.to_type === "App\\Models\\User" && aptPass.to.id === user.id) ||
      (aptPass.to_type === "App\\Models\\Room" &&
        userAssignedRooms &&
        userAssignedRooms.includes(aptPass.to.id))
    )
  },
  aptPassStatus(pass) {
    if (!pass) {
      return null
    }
    const user = store.getters["authentication/user"]
    const allUsersAssignedRooms =
      store.getters["dashboardTable/usersAssignedRooms"]
    const activeAppoinmentModuleOptions =
      store.getters["schools/activeAppoinmentModuleOptions"]
    const activeTab = store.getters["adultAptPass/activeTab"] // "next 7 days, beyond 7 days"
    const activePassType = store.getters["dashboardTable/getType"]
    const studentActiveTab = store.getters["studentAptPass/activeTab"]
    let usersAssignedRooms = []
    if (
      user &&
      allUsersAssignedRooms &&
      allUsersAssignedRooms.users &&
      allUsersAssignedRooms.users[user.id]
    ) {
      usersAssignedRooms = allUsersAssignedRooms.users[user.id]
    }
    //Define is_missed
    pass.is_missed = pass?.individual_pass_state === "MISSED"
    //Define is_canceled
    if (pass?.individual_pass_state === "CANCELED" || pass.canceled_at) {
      pass.is_canceled = true
    } else {
      pass.is_canceled = false
    }
    //Define waiting_activation
    pass.waiting_activation =
      pass?.individual_pass_state === "WAITING_ACTIVATION"
    //Define is_for_confirm
    pass.is_for_confirm = false
    if (
      !pass.confirmed_by_teacher_at &&
      !pass.canceled_at &&
      pass?.individual_pass_state !== "MISSED" &&
      pass.created_by_user &&
      pass.created_by_user.role_id == 1 &&
      moment(pass.for_date).isAfter(moment(), "second")
    ) {
      // if it's to them allow confirm
      if (pass.to_type == "App\\Models\\User" && pass.to.id == user.id) {
        pass.is_for_confirm = true
      }
      if (
        pass.to_type === "App\\Models\\Room" &&
        usersAssignedRooms.includes(pass.to.id)
      ) {
        pass.is_for_confirm = true
      }
      //Mark as for confirm if it's student
      if (
        pass.created_by_user &&
        pass.created_by_user.role_id == 1 &&
        user.role.id == 1
      ) {
        pass.is_for_confirm = true
      }
    }
    //Define is_for_acknowledge
    pass.is_for_acknowledge = false
    if (
      !pass.canceled_at &&
      pass?.individual_pass_state != "RUNNING" &&
      pass?.individual_pass_state != "LONG_RUNNING" &&
      pass?.individual_pass_state != "MISSED" &&
      pass?.individual_pass_state != "ENDED" &&
      pass?.individual_pass_state != "CANCELED" &&
      pass?.individual_pass_state != "WAITING_ACTIVATION" &&
      pass.confirmed_by_teacher_at != null &&
      !pass.acknowledged_by_user &&
      moment(pass.for_date).isAfter(moment(), "second")
    ) {
      // if the pass it's from system
      if (pass.from.id === 0) {
        pass.is_for_acknowledge = true
      }
      if (
        pass.from_type === "App\\Models\\Room" &&
        usersAssignedRooms.includes(pass.from.id)
      ) {
        // If the user is related with that location
        pass.is_for_acknowledge = true
      }
      // If it's related to the user
      if (pass.from_type === "App\\Models\\User" && pass.from.id === user.id) {
        pass.is_for_acknowledge = true
      }
    }
    //Define is_ended
    pass.is_ended = pass?.individual_pass_state == "ENDED"

    //Define can_be_canceled
    pass.can_be_canceled = false
    if (
      !pass.canceled_at &&
      (pass?.individual_pass_state == "IN_ANOTHER_PASS" ||
        pass?.individual_pass_state == "NEW") &&
      activePassType === "appointment" &&
      activeTab === "prevSevenDays"
    ) {
      pass.can_be_canceled = true
    }
    if (
      !pass.canceled_at &&
      (pass?.individual_pass_state == "IN_ANOTHER_PASS" ||
        pass?.individual_pass_state == "NEW") &&
      moment(pass.for_date).isAfter(moment(), "second")
    ) {
      // if it's from system
      if (pass.from.id === 0) {
        pass.can_be_canceled = true
      }
      // If it's related to the user
      if (pass.from_type === "App\\Models\\User" && pass.from.id === user.id) {
        pass.can_be_canceled = true
      }
      // If it's related to the user
      if (pass.to_type === "App\\Models\\User" && pass.to.id === user.id) {
        pass.can_be_canceled = true
      }
      // If it's in assigned location ad it's from them, we allow cancel
      if (
        pass.from_type === "App\\Models\\Room" &&
        usersAssignedRooms.includes(pass.from.id)
      ) {
        pass.can_be_canceled = true
      }
      if (
        pass.to_type === "App\\Models\\Room" &&
        usersAssignedRooms.includes(pass.to.id)
      ) {
        pass.can_be_canceled = true
      }
      if (
        (user.role_id == 2 || user.role_id == 4) &&
        activeAppoinmentModuleOptions &&
        !activeAppoinmentModuleOptions.admin_edit
      ) {
        pass.can_be_canceled = true
      }
      if (pass.created_by === user.id) {
        pass.can_be_canceled = true
      }
    }
    //Define is_for_today
    if (
      moment().isSame(moment(pass.for_date), "day") &&
      (pass?.individual_pass_state == "NEW" ||
        pass?.individual_pass_state != "CANCELED") &&
      pass?.individual_pass_state != "ENDED" &&
      (pass.confirmed_by_teacher_at != null ||
        pass.recurrence_appointment_pass_id != null)
    ) {
      pass.is_for_today = true
    } else {
      pass.is_for_today = false
    }
    //Define is_for_future
    if (
      pass?.individual_pass_state == "NEW" &&
      moment(pass.for_date).isAfter(moment(), "day") &&
      pass.confirmed_by_teacher_at != null
    ) {
      pass.is_for_future = true
    } else {
      if (
        pass?.individual_pass_state == "NEW" &&
        moment(
          pass.recurrence_appointment_pass &&
            pass.recurrence_appointment_pass.recurrence_end_at
        ).isSameOrAfter(moment(), "day") &&
        ((activeTab === "prevSevenDays" && user.role_id != 1) ||
          (studentActiveTab === "prevSevenDays" && user.role_id == 1))
      ) {
        pass.is_for_future = true
      } else {
        pass.is_for_future = false
      }
    }
    //Define is_missed_request
    pass.is_missed_request = false
    if (
      moment(pass.for_date).isBefore(moment(), "second") &&
      !pass.confirmed_by_teacher_at &&
      !pass.canceled_at &&
      !pass.recurrence_appointment_pass
    ) {
      pass.is_missed_request = true
    }
    //Define awaiting confirmation
    pass.is_today_waiting_confirmation = false
    if (
      moment(pass.for_date).isSameOrAfter(moment(), "second") &&
      moment().isSame(moment(pass.for_date), "day") &&
      pass?.individual_pass_state == "NEW" &&
      pass.confirmed_by_teacher_at == null &&
      this.isUserAssignedToRoom(pass)
    ) {
      pass.is_today_waiting_confirmation = true
    }
    //Define future awaiting confirmation
    pass.is_future_waiting_confirmation = false
    if (
      moment(pass.for_date).isAfter(moment(), "day") &&
      pass?.individual_pass_state == "NEW" &&
      pass.confirmed_by_teacher_at == null &&
      this.isUserAssignedToRoom(pass)
    ) {
      pass.is_future_waiting_confirmation = true
    }
    //Define can_be_edited
    pass.can_be_edited = false
    if (
      !pass.canceled_at &&
      (pass?.individual_pass_state == "IN_ANOTHER_PASS" ||
        pass?.individual_pass_state == "NEW") &&
      activePassType === "appointment" &&
      activeTab === "prevSevenDays"
    ) {
      pass.can_be_edited = true
    }
    if (
      !pass.canceled_at &&
      pass?.individual_pass_state == "NEW" &&
      moment(pass.for_date).isAfter(moment(), "second")
    ) {
      // If the user is admin and admin_edit option is checked we can edit the apt
      if (
        user.role_id === 2 &&
        activeAppoinmentModuleOptions &&
        !activeAppoinmentModuleOptions.admin_edit
      ) {
        pass.can_be_edited = true
      }
      // If the auth user is related with the location "From"
      if (
        pass.from_type === "App\\Models\\Room" &&
        usersAssignedRooms.includes(pass.from.id)
      ) {
        pass.can_be_edited = true
      }

      // If the auth user is related with the location "To"
      if (
        pass.to_type === "App\\Models\\Room" &&
        usersAssignedRooms.includes(pass.to.id)
      ) {
        pass.can_be_edited = true
      }

      // If the pass is from system
      if (pass.from.id === 0) {
        pass.can_be_edited = true
      }

      // If it's created by the user
      if (pass.created_by === user.id) {
        pass.can_be_edited = true
      }

      // If it's related to the user
      if (pass.from_type === "App\\Models\\User" && pass.from.id === user.id) {
        pass.can_be_edited = true
      }

      // If it's related to the user
      if (pass.to_type === "App\\Models\\User" && pass.to.id === user.id) {
        pass.can_be_edited = true
      }
    }
    //Define Activated
    pass.is_activated = pass?.individual_pass_state == "RUNNING"
    pass.is_long_running = pass?.individual_pass_state == "LONG_RUNNING"
    //Define is_in_another_pass
    pass.is_in_another_pass = pass?.individual_pass_state == "IN_ANOTHER_PASS"

    return pass
  },
  isDateInSevenDays(day) {
    return moment(day).isBetween(
      moment(),
      moment().endOf("day").add(7, "days", "[]")
    )
  },
  isAptInSelectedTab(aptPass) {
    const activePassType = store.getters["dashboardTable/getType"]
    const activeTab = store.getters["adultAptPass/activeTab"]

    return (
      activePassType.includes("appointment") &&
      ((activeTab === "nextSevenDays" &&
        this.isDateInSevenDays(aptPass.for_date)) ||
        (activeTab === "prevSevenDays" &&
          !this.isDateInSevenDays(aptPass.for_date)))
    )
  },
  isAptInSelectedTabStudent(aptPass) {
    const activeTab = store.getters["studentAptPass/activeTab"]
    return (
      (activeTab === "nextSevenDays" &&
        this.isDateInSevenDays(aptPass?.for_date)) ||
      (activeTab === "prevSevenDays" &&
        !this.isDateInSevenDays(aptPass?.for_date))
    )
  },
  stringDateRange(start, end) {
    return start.format("MM/DD/YYYY") + " - " + end.format("MM/DD/YYYY")
  },
  minSchoolYearDate() {
    const now = moment()
    const currentMonth = now.month()
    if (currentMonth < 6) {
      return new Date(now.year() - 1, 6, 1)
    }

    return new Date(now.year(), 6, 1)
  },
  maxSchoolYearDate() {
    const now = moment()
    const currentMonth = now.month()
    if (currentMonth < 6) {
      return new Date(now.year(), 5, 30)
    }

    return new Date(now.year() + 1, 5, 30)
  },
  isPreviousYearDate(date) {
    return (
      moment(this.currTzDate(date)) <
      moment(this.currTzDate(this.minSchoolYearDate()))
    )
  },
  isPassExceedingSystemEndTime(pass) {
    const approvedAtPlusEndTime = this.getPassEndTime(pass)

    const status = pass.child ? pass.child.pass_status : pass.pass_status

    return status == 1 && moment().isAfter(approvedAtPlusEndTime)
  },
  getPassEndTime(pass) {
    const approvedAtPlusEndTime = moment(pass.approved_at)

    const expireTime = pass.expire_after.split(":")

    approvedAtPlusEndTime.add(expireTime[0], "hours")
    approvedAtPlusEndTime.add(expireTime[1], "minutes")
    approvedAtPlusEndTime.add(expireTime[2], "seconds")

    return approvedAtPlusEndTime
  },
  clearVisitorLocalStorage() {
    const keys = [
      visitorConstants.VISITOR_LOCAL_STORAGE_KEYS.PRINTER_ID,
      visitorConstants.VISITOR_LOCAL_STORAGE_KEYS.PRINTER_NAME,
      visitorConstants.VISITOR_LOCAL_STORAGE_KEYS.PRINTER_BRAND,
      visitorConstants.VISITOR_LOCAL_STORAGE_KEYS.USER,
      visitorConstants.VISITOR_LOCAL_STORAGE_KEYS.STOP_AUTO_DETECT,
      visitorConstants.VISITOR_LOCAL_STORAGE_KEYS
        .SHOW_VISITOR_SIGNED_IN_LIST_MODAL,
      visitorConstants.VISITOR_LOCAL_STORAGE_KEYS.DEFAULT_CAMERA,
      visitorConstants.VISITOR_LOCAL_STORAGE_KEYS.FCM_TOKEN
    ]

    keys.forEach((key) => localStorage.removeItem(key))
  },
  numberValidator(value) {
    const regex = /^\(\d{3}\) \d{3}-\d{4}$/
    return regex.test(value)
  },
  alphaSpaceValidator(value) {
    const regex = /^[A-Za-z\s]+$/
    return regex.test(value)
  },
  alphaNumSpaceSpecialCharacterValidator(value) {
    const regex = /^[A-Za-z0-9\s\-,&:_@.]+$/
    return regex.test(value)
  },
  phoneNumberFormatter(number) {
    if (helpers.numberValidator(number)) {
      return number
    }
    let str = number.toString().replace(/\D/g, "")
    while (str.length < 10) {
      str = str + "0"
    }
    return `(${str.slice(0, 3)}) ${str.slice(3, 6)}-${str.slice(6)}`
  },
  downloadFileByPath: (filePath) => {
    const link = document.createElement("a")
    link.href = filePath
    link.target = "_blank"
    link.download = filePath.split("/").pop()
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },
  getCurrentTimezoneName: () => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const smallCaseTimeZone = timeZone?.trim()?.toLowerCase()
    const map = {
      "asia/calcutta": "Asia/Kolkata"
    }
    return map[smallCaseTimeZone] || timeZone
  },
  convertToCurrentTimezone: (
    dateTime,
    isUTC = true,
    format = "MM-DD-YYYY h:mm A",
    returnDateOnly = false
  ) => {
    const adjustedDateTime = isUTC ? moment.utc(dateTime) : moment(dateTime)
    const currentTimezone = helpers.getCurrentTimezoneName()
    const dateTimePart = adjustedDateTime.tz(currentTimezone).format(format)
    const datePart = dateTimePart?.split?.(" ")?.[0] || ""
    return returnDateOnly ? datePart : dateTimePart
  },
  stringDateRangeWithTimezone: (start, end) => {
    const startDate = helpers.convertToCurrentTimezone(
      start,
      false,
      "MM/DD/YYYY",
      true
    )
    const endDate = helpers.convertToCurrentTimezone(
      end,
      false,
      "MM/DD/YYYY",
      true
    )
    return `${startDate} - ${endDate}`
  },
  imageUrlToBase64: async (url) => {
    const data = await fetch(url)
    const blob = await data.blob()
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onloadend = () => {
        const base64data = reader.result
        const pngData = base64data.replace(
          /^data:.*,/,
          "data:image/png;base64,"
        )
        resolve(pngData)
      }
      reader.onerror = reject
    })
  },
  getFormattedDateWithoutTimezone: (date, format = "MM-DD-YYYY") => {
    return moment(date).format(format)
  },
  execPromiseWithTimeout: (promise, timeout, message) => {
    return Promise.race([
      promise,
      new Promise((_, reject) =>
        setTimeout(
          () => reject(new Error(message || "Operation timed out")),
          timeout
        )
      )
    ])
  },
  isPassActive: (pass) => {
    return (
      Number(pass?.child?.pass_status) === 1 || Number(pass?.pass_status) === 1
    )
  },
  /**
   * Converts a time string from local timezone to UTC
   * @param {string} time - Time string in format "HH:mm"
   * @param {string} timezone - The source timezone (if null, uses active school timezone)
   * @param {string} format - The format of the input time string
   * @returns {string} - Time string in UTC format "HH:mm"
   */
  convertTimeToUTC: (time, timezone = null, format = "HH:mm") => {
    const timeZone =
      timezone || store?.getters?.["schools/activeSchoolTimeZone"]
    return moment.tz(time, format, timeZone).utc().format(format)
  },
  /**
   * Converts a 24-hour UTC time to 12-hour AM/PM format in school timezone
   * @param {string} utcTime - UTC time string in format "HH:mm"
   * @param {string} timezone - The target timezone (if null, uses active school timezone)
   * @param {string} outputFormat - The desired output format
   * @returns {string} - Formatted time string in school timezone
   */
  convertUTCToLocalTime: (
    utcTime,
    timezone = null,
    outputFormat = "hh:mm A"
  ) => {
    const timeZone =
      timezone || store?.getters?.["schools/activeSchoolTimeZone"]
    return moment
      .utc(utcTime, "YYYY-MM-DD HH:mm")
      .tz(timeZone)
      .format(outputFormat)
  },
  /**
   * Updates and filters a pass based on the specified type.
   *
   * @param {Object} pass - The pass object to update and filter.
   * @param {string} type - The type of filter to apply. Must be one of the passConstants.PASS_TYPE_NAMES values.
   * @returns {boolean} - Returns true if the pass matches the filter criteria, otherwise false.
   */
  updateAndFilterPassByPassType: (pass, type) => {
    let updatedPass = cloneDeep(pass)
    updatedPass.badge_flags = helpers.getBadgeFlags(updatedPass)
    updatedPass.total_time = helpers.getTotalTime(updatedPass)
    updatedPass = helpers.setUserAssignedRoomsPerPass(updatedPass)

    switch (type) {
      case passConstants.PASS_TYPE_NAMES.TOTAL:
        // Filter for total passes excluding those waiting for approval or missed
        return (
          !updatedPass.badge_flags.waiting_approval &&
          !updatedPass.badge_flags.missed
        )
      case passConstants.PASS_TYPE_NAMES.ACTIVE:
        // Filter for active passes excluding those waiting for approval or missed
        return (
          !updatedPass.badge_flags.waiting_approval &&
          !updatedPass.badge_flags.missed &&
          helpers.isPassActive(updatedPass)
        )
      case passConstants.PASS_TYPE_NAMES.MY:
        // Filter for passes that count as "my" passes
        return (
          helpers.doesCountMyPass(updatedPass) &&
          !(
            updatedPass.badge_flags.missed ||
            updatedPass.badge_flags.canceled ||
            updatedPass.badge_flags.waiting_approval
          )
        )
      case passConstants.PASS_TYPE_NAMES.MY_ACTIVE:
        // Filter for active passes that count as "my" passes
        return (
          !updatedPass.badge_flags.waiting_approval &&
          helpers.doesCountMyPass(updatedPass) &&
          helpers.isPassActive(updatedPass)
        )
      case passConstants.PASS_TYPE_NAMES.FLAGGED:
        // Filter for flagged passes that count as "my" passes
        return (
          helpers.doesCountMyPass(updatedPass) &&
          (updatedPass.badge_flags.extended ||
            updatedPass.badge_flags.system_completed ||
            updatedPass.badge_flags.min_time)
        )
      case passConstants.PASS_TYPE_NAMES.WAITING_FOR_APPROVAL:
        // Filter for passes waiting for approval that count as "my" passes
        return (
          updatedPass.badge_flags.waiting_approval &&
          helpers.doesCountMyPass(updatedPass) &&
          !(updatedPass.badge_flags.missed || updatedPass.badge_flags.canceled)
        )
      default:
        return false
    }
  },
  updateAppointmentMetrics: (pass, type) => {
    const isToday = helpers.filterAptPassesByTab(pass, "appointments_today")
    const isAwaitingToday = helpers.filterAptPassesByTab(
      pass,
      "appointments_awaiting"
    )
    const isFuture = helpers.filterAptPassesByTab(
      pass,
      "appointments_future_awaiting"
    )
    if (isToday) {
      store.commit("dashboardCounters/UPDATE_APPOINTMENT_METRICS", {
        key: passConstants.APPOINTMENT_METRICS_KEY.TODAY,
        type
      })
    }
    if (isAwaitingToday) {
      store.commit("dashboardCounters/UPDATE_APPOINTMENT_METRICS", {
        key: passConstants.APPOINTMENT_METRICS_KEY.AWAITING_TODAY,
        type
      })
    }
    if (isFuture) {
      store.commit("dashboardCounters/UPDATE_APPOINTMENT_METRICS", {
        key: passConstants.APPOINTMENT_METRICS_KEY.FUTURE,
        type
      })
    }
  },
  isPassFromSameDay: (passDate, timezoneParam = null) => {
    const schoolTimezone =
      timezoneParam || store?.getters?.["schools/activeSchoolTimeZone"]
    const currentActiveSchoolDate = moment().tz(schoolTimezone).startOf("day")
    const passCompletedDate = moment(passDate).tz(schoolTimezone).startOf("day")
    return currentActiveSchoolDate.isSame(passCompletedDate, "day")
  },
  generateHash(message) {
    if (!message || typeof message !== "string") {
      throw new Error("Input must be a non-empty string")
    }
    return this.sha256(message)
  },
  sha256(ascii) {
    for (let i = 0; i < ascii.length; i++) {
      if (ascii.charCodeAt(i) > 127) {
        throw new Error("Only ASCII strings are supported")
      }
    }
    const rightRotate = (value, amount) =>
      (value >>> amount) | (value << (32 - amount))
    const toHex = (value) => (value < 16 ? "0" : "") + value.toString(16)

    const maxWord = Math.pow(2, 32)
    const asciiBitLength = ascii.length * 8
    const words = []
    let result = ""
    const paddedMessage =
      ascii + "\x80" + "\x00".repeat((64 - ((ascii.length + 9) % 64)) % 64)

    for (let i = 0; i < paddedMessage.length; i++) {
      const code = paddedMessage.charCodeAt(i)
      if (code >> 8) throw new Error("Only ASCII strings are supported")
      words[i >> 2] |= code << (((3 - i) % 4) * 8)
    }

    words[words.length] = (asciiBitLength / maxWord) | 0
    words[words.length] = asciiBitLength

    let hash = [...SHA256_INITIAL_HASH]

    for (let j = 0; j < words.length;) {
      const w = words.slice(j, (j += 16))
      const oldHash = [...hash]

      for (let i = 0; i < 64; i++) {
        const w15 = w[i - 15]
        const w2 = w[i - 2]

        w[i] =
          i < 16
            ? w[i]
            : (w[i - 16] +
                (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3)) +
                w[i - 7] +
                (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10))) |
              0

        const a = hash[0]
        const e = hash[4]
        const temp1 =
          (hash[7] +
            (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) +
            ((e & hash[5]) ^ (~e & hash[6])) +
            SHA256_ROUND_CONSTANTS[i] +
            w[i]) |
          0
        const temp2 =
          ((rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) +
            ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2]))) |
          0

        hash = [
          (temp1 + temp2) | 0,
          hash[0],
          hash[1],
          hash[2],
          (hash[3] + temp1) | 0,
          hash[4],
          hash[5],
          hash[6]
        ]
      }

      for (let i = 0; i < 8; i++) {
        hash[i] = (hash[i] + oldHash[i]) | 0
      }
    }

    for (let i = 0; i < 8; i++) {
      for (let j = 3; j + 1; j--) {
        const b = (hash[i] >> (j * 8)) & 255
        result += toHex(b)
      }
    }

    return result
  },
  isHallwayPass: (pass) => {
    const isMainPassActive =
      Number(pass?.pass_status) === 1 && pass?.approved_at != null
    const isChildPassActive =
      pass?.child &&
      Number(pass?.child?.pass_status) === 1 &&
      pass?.child?.approved_at != null
    return isMainPassActive || isChildPassActive
  },
  loadFullStory: () => {
    // Check if FullStory is already loaded
    if (typeof window.FS !== "undefined" || window._fs_script) {
      return
    }

    // Set FullStory configuration
    window["_fs_host"] = "fullstory.com"
    window["_fs_script"] = "edge.fullstory.com/s/fs.js"
    window["_fs_org"] = "o-235P2C-na1"
    window["_fs_namespace"] = "FS"

    // FullStory script
    !(function (m, n, e, t, l, o, g, y) {
      var s,
        f,
        a = (function (h) {
          return (
            !(h in m) ||
            (m.console &&
              m.console.log &&
              m.console.log(
                'FullStory namespace conflict. Please set window["_fs_namespace"].'
              ),
            !1)
          )
        })(e)
      function p(b) {
        var h,
          d = []
        function j() {
          h &&
            (d.forEach(function (b) {
              var d
              try {
                d = b[h[0]] && b[h[0]](h[1])
              } catch (h) {
                return void (b[3] && b[3](h))
              }
              d && d.then ? d.then(b[2], b[3]) : b[2] && b[2](d)
            }),
            (d.length = 0))
        }
        function r(b) {
          return function (d) {
            h || ((h = [b, d]), j())
          }
        }
        return (
          b(r(0), r(1)),
          {
            then: function (b, h) {
              return p(function (r, i) {
                ;(d.push([b, h, r, i]), j())
              })
            }
          }
        )
      }
      a &&
        ((g = m[e] =
          (function () {
            var b = function (b, d, j, r) {
              function i(i, c) {
                h(b, d, j, i, c, r)
              }
              r = r || 2
              var c,
                u = /Async$/
              return u.test(b)
                ? ((b = b.replace(u, "")),
                  "function" == typeof Promise ? new Promise(i) : p(i))
                : h(b, d, j, c, c, r)
            }
            function h(h, d, j, r, i, c) {
              return b._api
                ? b._api(h, d, j, r, i, c)
                : (b.q && b.q.push([h, d, j, r, i, c]), null)
            }
            return ((b.q = []), b)
          })()),
        (y = function (b) {
          function h(h) {
            "function" == typeof h[4] && h[4](new Error(b))
          }
          var d = g.q
          if (d) {
            for (var j = 0; j < d.length; j++) h(d[j])
            ;((d.length = 0), (d.push = h))
          }
        }),
        (function () {
          ;(((o = n.createElement(t)).async = !0),
            (o.crossOrigin = "anonymous"),
            (o.src = "https://" + l),
            (o.onerror = function () {
              y("Error loading " + l)
            }))
          var b = n.getElementsByTagName(t)[0]
          b && b.parentNode
            ? b.parentNode.insertBefore(o, b)
            : n.head.appendChild(o)
        })(),
        (function () {
          function b() {}
          function h(b, h, d) {
            g(b, h, d, 1)
          }
          function d(b, d, j) {
            h("setProperties", { type: b, properties: d }, j)
          }
          function j(b, h) {
            d("user", b, h)
          }
          function r(b, h, d) {
            ;(j(
              {
                uid: b
              },
              d
            ),
              h && j(h, d))
          }
          ;((g.identify = r),
            (g.setUserVars = j),
            (g.identifyAccount = b),
            (g.clearUserCookie = b),
            (g.setVars = d),
            (g.event = function (b, d, j) {
              h(
                "trackEvent",
                {
                  name: b,
                  properties: d
                },
                j
              )
            }),
            (g.anonymize = function () {
              r(!1)
            }),
            (g.shutdown = function () {
              h("shutdown")
            }),
            (g.restart = function () {
              h("restart")
            }),
            (g.log = function (b, d) {
              h("log", { level: b, msg: d })
            }),
            (g.consent = function (b) {
              h("setIdentity", { consent: !arguments.length || b })
            }))
        })(),
        (s = "fetch"),
        (f = "XMLHttpRequest"),
        (g._w = {}),
        (g._w[f] = m[f]),
        (g._w[s] = m[s]),
        m[s] &&
          (m[s] = function () {
            return g._w[s].apply(this, arguments)
          }),
        (g._v = "2.0.0"))
    })(window, document, window._fs_namespace, "script", window._fs_script)
  },
  loadGainsight: (pxTag) => {
    if (typeof window.aptrinsic !== "undefined") {
      return
    }

    // Gainsight PX script
    ;(function (n, t, a, e, co) {
      var i = "aptrinsic"
      ;((n[i] =
        n[i] ||
        function () {
          ;(n[i].q = n[i].q || []).push(arguments)
        }),
        (n[i].p = e))
      n[i].c = co
      var r = t.createElement("script")
      ;((r.async = !0), (r.src = a + "?a=" + e))
      var c = t.getElementsByTagName("script")[0]
      c.parentNode.insertBefore(r, c)
    })(
      window,
      document,
      "https://web-sdk.aptrinsic.com/api/aptrinsic.js",
      pxTag
    )
  },
  shutdownFullStory: () => {
    if (typeof window.FS !== "undefined") {
      window.FS("shutdown")
    }
  },
  restartFullStory: () => {
    if (typeof window.FS !== "undefined") {
      window.FS("restart")
    }
  },
  resetGainsight: () => {
    if (typeof window.aptrinsic !== "undefined") {
      window.aptrinsic("reset")
    }
  }
}

export default helpers
